﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as nouislider from 'nouislider';

import config from '../../../../common/config';

import * as Entities_Memory_Position from '../../../entities/memoryposition';

import tpl_pictureSlideListItemProperties from './tpl/pictureSlideListItemProperties.html';

export default Marionette.LayoutView.extend({
    dialogRegion2: '#pictureSlideListItemProperties_modal',
    errors: [],
    getTemplate: function () {
        return tpl_pictureSlideListItemProperties({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;
    },
    regions: {
    },
    onBeforeShow: function () {
    },
    ui: {
        'pictureSlideListItemProperties_group_Duration': '#pictureSlideListItemProperties_group_Duration',
        'pictureSlideListItemProperties_input_Duration': '#pictureSlideListItemProperties_input_Duration',
        'pictureSlideListItemProperties_label_Duration': '#pictureSlideListItemProperties_label_Duration',
        'pictureSlideListItemProperties_dropDown_Animation': '#pictureSlideListItemProperties_dropDown_Animation',
        'pictureSlideListItemProperties_input_Text': '#pictureSlideListItemProperties_input_Text',

        'pictureSlideListItemProperties_image': '#pictureSlideListItemProperties_image',
        'pictureSlideListItemProperties_btn_crop_zoom_plus': '#pictureSlideListItemProperties_btn_crop_zoom_plus',
        'pictureSlideListItemProperties_btn_crop_zoom_minus': '#pictureSlideListItemProperties_btn_crop_zoom_minus',
        'pictureSlideListItemProperties_btn_crop_move_left': '#pictureSlideListItemProperties_btn_crop_move_left',
        'pictureSlideListItemProperties_btn_crop_move_right': '#pictureSlideListItemProperties_btn_crop_move_right',
        'pictureSlideListItemProperties_btn_crop_move_top': '#pictureSlideListItemProperties_btn_crop_move_top',
        'pictureSlideListItemProperties_btn_crop_move_buttom': '#pictureSlideListItemProperties_btn_crop_move_buttom',
        'pictureSlideListItemProperties_btn_crop_rotate_left': '#pictureSlideListItemProperties_btn_crop_rotate_left',
        'pictureSlideListItemProperties_btn_crop_rotate_right': '#pictureSlideListItemProperties_btn_crop_rotate_right',
        'pictureSlideListItemProperties_btn_crop_scale_x': '#pictureSlideListItemProperties_btn_crop_scale_x',
        'pictureSlideListItemProperties_btn_crop_scale_y': '#pictureSlideListItemProperties_btn_crop_scale_y',
        'pictureSlideListItemProperties_btnSubmit': '#pictureSlideListItemProperties_btnSubmit',

        'pictureSlideListItemProperties_btn01': '#pictureSlideListItemProperties_btn01',
        'pictureSlideListItemProperties_btn02': '#pictureSlideListItemProperties_btn02'
    },
    events: {
        'click @ui.pictureSlideListItemProperties_btn01': 'onBtn01',
        'click @ui.pictureSlideListItemProperties_btn02': 'onBtn02',

        'click @ui.pictureSlideListItemProperties_btn_crop_zoom_plus': 'btnZoomPlusClick',
        'click @ui.pictureSlideListItemProperties_btn_crop_zoom_minus': 'btnZoomMinusClick',
        'click @ui.pictureSlideListItemProperties_btn_crop_move_left': 'btnMoveLeftClick',
        'click @ui.pictureSlideListItemProperties_btn_crop_move_right': 'btnMoveRightClick',
        'click @ui.pictureSlideListItemProperties_btn_crop_move_top': 'btnMoveTopClick',
        'click @ui.pictureSlideListItemProperties_btn_crop_move_buttom': 'btnMoveButtomClick',
        'click @ui.pictureSlideListItemProperties_btn_crop_rotate_left': 'btnRotateLeftClick',
        'click @ui.pictureSlideListItemProperties_btn_crop_rotate_right': 'btnRotateRightClick',
        'click @ui.pictureSlideListItemProperties_btn_crop_scale_x': 'btnScaleXClick',
        'click @ui.pictureSlideListItemProperties_btn_crop_scale_y': 'btnScaleYClick',
        'click @ui.pictureSlideListItemProperties_btnSubmit': 'btnSetImage',
    },
    onRender: function () {
    },
    onAttach() {
        var self = this;

        this.ui.pictureSlideListItemProperties_input_Duration.durationPicker({
            translations: {
                day: resources.X101498,
                hour: resources.X101499,
                minute: resources.X101500,
                second: resources.X101501,
                days: resources.X101502,
                hours: resources.X101503,
                minutes: resources.X101504,
                seconds: resources.X101505,
            },
            showSeconds: true,
            onChanged: function (newVal) {
                self.ui.pictureSlideListItemProperties_label_Duration.text(newVal);
                self.model.set({
                    Duration: newVal
                });
            }
        });

        $('.bdp-block.hidden').css('display', 'none');

        this.setupAnimation();

        $('#pictureSlideListItemProperties_group_Duration').find('.input-sm').width(90);
        //this.ui.pictureSlideListItemProperties_group_Duration.find('.input-sm').css('width', '90px;');

        this.setupCropper();
    },
    setupAnimation: function () {
        var self = this;

        this.ui.pictureSlideListItemProperties_dropDown_Animation.empty();

        var selected = '';

        self.app.entities.collections.PictureSlideAnimation.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Animation == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.pictureSlideListItemProperties_dropDown_Animation.append(options);
        });
    },
    setupDuration: function () {
        var self = this;

        this.ui.pictureSlideListItemProperties_dropDown_Duration.empty();

        var selected = '';

        self.app.entities.collections.PictureSlideDuration.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Duration == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.pictureSlideListItemProperties_dropDown_Duration.append(options);
        });
    },
    setupCropper: function () {
        this.ui.pictureSlideListItemProperties_image.attr('src', this.model.attributes.InfoImage_ImageUrl);

        //var previews = document.querySelectorAll('.cropper-img-preview');
        var imageDefault = document.querySelector('#pictureSlideListItemProperties_image');

        var cropBoxData;
        var canvasData;


        this.cropper = new Cropper(imageDefault, {
            //viewMode: 1,
            //responsive: true,
            aspectRatio: 1 / 1,
            minContainerWidth: 300,
            minContainerHeight: 300,
            //maxContainerWidth: 500,
            //maxContainerHeight: 500,
            autoCropArea: 0.8,
            zoomOnTouch: false,
            zoomOnWheel: false,
            cropBoxResizable: true,
        });
    },
    getImage: function (width, height) {
        if (this.cropper) {
            var cropBoxData = this.cropper.getCropBoxData();
            var croppedCanvas;
            var canvas;

            croppedCanvas = this.cropper.getCroppedCanvas();
            canvas = this.getWeboptimizeCanvas(croppedCanvas, width, height);

            return canvas.toDataURL();
        }
    },
    fillup: function (text) {
        if (text.length <= 1) {
            text = '0' + text;
        }
        return text;
    },
    UUID: function () {
        var lut = [];
        for (var i = 0; i < 256; i++) {
            lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
        }

        var d0 = Math.random() * 0xffffffff | 0;
        var d1 = Math.random() * 0xffffffff | 0;
        var d2 = Math.random() * 0xffffffff | 0;
        var d3 = Math.random() * 0xffffffff | 0;

        return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
            lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
            lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
            lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
    },
    saveImage: function (callback, imageData, imageMime) {
        var nowLocalDate = new Date();

        var strLocalDate = nowLocalDate.getFullYear().toString() +
            this.fillup((nowLocalDate.getMonth() + 1).toString()) +
            this.fillup(nowLocalDate.getDate().toString()) +
            this.fillup(nowLocalDate.getHours().toString()) +
            this.fillup(nowLocalDate.getMinutes().toString()) +
            this.fillup(nowLocalDate.getSeconds().toString()) +
            nowLocalDate.getMilliseconds().toString();


        var filename = strLocalDate + " - " + "Test";
        var sizeType = 1;
        var sizeText = "750X750";
        var sortType = 1;
        var uuid = this.UUID();

        var changeDate = new Date();
        var strUtcDate = changeDate.getUTCFullYear().toString() + '-' +
            (changeDate.getUTCMonth() + 1) + '-' +
            changeDate.getUTCDate().toString() + ' ' +
            changeDate.getUTCHours() + ':' +
            changeDate.getUTCMinutes() + ':' +
            changeDate.getUTCSeconds() + '.';



        var tmpModel = new this.app.entities.collections.customInfoImage.model();
        //tmpModel.attributes.id = null;
        tmpModel.attributes.AuthUserId = config.authUserId();
        tmpModel.attributes.Name = filename;
        tmpModel.attributes.ImageData = imageData;
        tmpModel.attributes.ImageMimeType = imageMime;
        tmpModel.attributes.ImageUpdate = true;
        tmpModel.attributes.SizeType = sizeType;
        tmpModel.attributes.SizeText = sizeText;
        tmpModel.attributes.SortType = sortType;
        tmpModel.attributes.CommonId = uuid;
        tmpModel.attributes.UtcDate = strUtcDate;
        tmpModel.attributes.Filename = filename + '.png';

        this.app.entities.collections.customInfoImage.create(tmpModel, {
            wait: true,
            success: function (response) {
                callback(response);
            }
        });

    },
    getWeboptimizeCanvas: function (sourceCanvas, width, height) {
        var canvas = document.createElement('canvas');

        var context = canvas.getContext('2d');

        canvas.width = width;
        canvas.height = height;
        context.beginPath();
        context.drawImage(sourceCanvas, 0, 0, width, height);

        return canvas;
    },
    btnSetImage: function (event) {
        event.preventDefault();

        var self = this;

        var base64 = self.getImage(750, 750);
        var searchString = ";base64,";
        var pos = base64.indexOf(searchString);
        var imageMime = base64.substring(5, pos);
        var imageData = base64.substring(pos + searchString.length, base64.length);

        var callbackSaveImage = function (model) {
            var oldInfoImage = self.model.attributes.InfoImage_id;
            self.model.attributes.id = model.attributes.id;
            self.model.attributes.InfoImage_id = model.attributes.id;
            self.model.attributes.InfoImage_ImageUrl = model.attributes.ImageUrl;
            self.model.attributes.InfoImage_Name = model.attributes.Name;

            /*self.model.attributes.ImageUrl = model.attributes.ImageUrl;
            self.model.attributes.CommonId = model.attributes.CommonId;
            self.model.attributes.id = model.attributes.id;*/

            //Remove old model in both this collection and CustomImageInfo
            var customInfoImageModel = self.app.entities.collections.customInfoImage.where({ id: oldInfoImage })[0];
            if (customInfoImageModel != undefined) {
                customInfoImageModel.destroy({
                    wait: true,
                    success: function (model, response) {
                    },
                    error: function (model, response) {
                    }
                });
            }
        }

        self.saveImage(callbackSaveImage, imageData, imageMime);
    },
    btnZoomPlusClick: function (event) {
        event.preventDefault();
        this.cropper.zoom(0.1);
    },
    btnZoomMinusClick: function (event) {
        event.preventDefault();
        this.cropper.zoom(-0.1);
    },
    btnMoveLeftClick: function (event) {
        event.preventDefault();
        this.cropper.move(-10, 0);
    },
    btnMoveRightClick: function (event) {
        event.preventDefault();
        this.cropper.move(10, 0);
    },
    btnMoveTopClick: function (event) {
        event.preventDefault();
        this.cropper.move(0, -10);
    },
    btnMoveButtomClick: function (event) {
        event.preventDefault();
        this.cropper.move(0, 10);
    },
    btnRotateLeftClick: function (event) {
        event.preventDefault();
        this.cropper.rotate(-90);
    },
    btnRotateRightClick: function (event) {
        event.preventDefault();
        this.cropper.rotate(90);
    },
    btnScaleXClick: function (event) {
        event.preventDefault();

        switch (this.cropper.getData().scaleX) {
            case 1: this.cropper.scaleX(-1); break;
            case -1: this.cropper.scaleX(1); break;
        }
    },
    btnScaleYClick: function (event) {
        event.preventDefault();

        switch (this.cropper.getData().scaleY) {
            case 1: this.cropper.scaleY(-1); break;
            case -1: this.cropper.scaleY(1); break;
        }
    },
    onBtn01: function () {
        var self = this;

        self.setModel();

        var callback = function () {
            self.trigger("dialog:close");
            self.triggerMethod('dialog:btn01clicked', "msg");
        }

        this.validate(callback);
    },
    onBtn02: function () {
        this.triggerMethod('dialog:btn02clicked', "msg");
        this.trigger("dialog:close");
    },
    showErrors: function (errors) {
        _.each(errors, function (error) {
            var controlGroup = this.$('.' + error.name);
            controlGroup.addClass('error');
            controlGroup.find('.help-inline').text(error.message);
        }, this);
    },
    hideErrors: function () {
        this.$('.control-group').removeClass('error');
        this.$('.help-inline').text('');

        this.errors = [];
    },
    validate: function (callback) {
        var self = this;
        this.hideErrors();
        callback();
    },
    setModel: function () {
        this.model.set({
            Animation: this.ui.pictureSlideListItemProperties_dropDown_Animation.val(),
            Text: this.ui.pictureSlideListItemProperties_input_Text.val()
        });
    },
    setupCssStyle: function () {
    }
});